<div class="race-details-panel" [ngClass]="{'disabled': disabled}" [attr.id]="panelId"
     [class.required]="panelStatus === 'required'" [class.needed]="isUsed === 'needed'"
     [class.error]="panelStatus === 'error'">
  <div class="race-details-panel__title">
    <ng-content></ng-content>
  </div>
  <div class="edit-icon-box">
    <i class="bi bi-pen"></i>
  </div>
</div>
